import { render } from "./BInputGroupAppend.vue?vue&type=template&id=662075e0"
import script from "./BInputGroupAppend.vue?vue&type=script&lang=js"
export * from "./BInputGroupAppend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__